import { render, staticRenderFns } from "./TableControls.vue?vue&type=template&id=82a7fbe6&"
import script from "./TableControls.vue?vue&type=script&lang=ts&"
export * from "./TableControls.vue?vue&type=script&lang=ts&"
import style0 from "./TableControls.vue?vue&type=style&index=0&id=82a7fbe6&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports